import { Attributes, ModelBase, Validation } from '@singularsystems/neo-core';

export default class StartQuestionnaireAnswerCommand extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public questionnaireId: number = 0;

    @Attributes.Nullable()
    public participantOfferId: number | null = null;

    @Attributes.Nullable()
    public surveyParticipantId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        rules.failWhen(command => !command.participantOfferId && !command.surveyParticipantId, "Either Participant Offer or Participant Survey must be provided");
    }

    public toString(): string {
        if (this.isNew) {
            return "New start questionnaire answer command";
        } else {
            return "Start Questionnaire Answer Command";
        }
    }
}